<template>
    <v-content grid-list-xl>
        <v-toolbar color="secondary" dark>
            <v-tooltip top eager color="secondary">
                <template v-slot:activator="{ on }">    
                    <v-toolbar-title v-on="on" :style="$store.state.textFormatting.headers"> Disaggregation events </v-toolbar-title>
                </template>
                <span :style="$store.state.textFormatting.headers"> Disaggregation events</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <downloadcsv
            class   = "btn btn-default"
            :data   = "disagdata"
            name = "disag.csv">
                <v-tooltip top eager color="primary" id="exit-app" v-if="disagdata">
                    <template v-slot:activator="{ on }">
                        <v-btn small dark v-on="on" color="success" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> Disaggregation events </v-btn>
                    </template>
                    <span :style="$store.state.textFormatting.main">Download Disaggregation events</span>
                </v-tooltip>
            </downloadcsv>
            <v-flex shrink>
                <v-btn @click="showAll=!showAll" v-if="showAll" dark fab small color="blue"><h2> - </h2></v-btn>
                <v-btn @click="showAll=!showAll" v-if="!showAll" dark fab small color="blue"><h2> + </h2></v-btn>
            </v-flex>
            <info>
                <template>
                    Disaggregation Table
                </template>
                <template slot="body">
                    <p> Disaggregation events occur when an ASN advertises a prefix which is <b>more or less specific</b> than an already existing advertised prefix. </p>
                    <br>
                    <p> Here a history of the disaggregation events which have occured on this prefix are displayed </p>
                    <br>
                    <p> Zoom in and out on the table to focus on data points.</p>
                    <br />
                    <b> Disaggregation history is stored for the duration of the database's existence (i.e. back to April 2019) </b>
                    <br />
                    <p> The legend in the graph below will only display if there are less than 10 ASNs involved </p>
                    <br />
                    <v-divider />
                    <br />
                    <p> <b>Difference between Disaggregation and prefix routing (Prefix last seen 'n' day(s) ago) </b></p>
                    <p> <b>Disaggregation</b>: Looks at the assertion level of the system (prior to events being created), to see when any 
                        <b>parent</b> or <b>child</b> prefix has had it's ownership asserted over. It may or may not have created an event,
                        hence doesn't tie directly to the events created in the system.
                    </p>
                    <p> <b>Prefix routing</b>: Looks only at the prefix of interest, and at the event level of the system (once events <b>have</b> been created).
                        These will therefore have a direct link to the events in the system and can therefore be inspected via the website.
                    </p>
                </template>
                <template slot="action">
                    <v-btn @click="disagRoute" flat color="primary" :style="$store.state.textFormatting.main"> More Disag</v-btn>
                </template>
            </info>
            

        </v-toolbar>
        <v-card v-if="showAll">
            <v-card-text>
                <v-layout align-start justify-center wrap>
                    <v-flex xs12 v-if="loading">
                        <v-progress-circular indeterminate color="purple"> </v-progress-circular>
                    </v-flex>
                    <v-flex xs12 v-if="!loading">
                        <v-card>
                            <v-card-text>
                            <scat-chart :chart-data="scatdata2" :options="options"></scat-chart> 
                            </v-card-text>
                            
                        </v-card>
                    </v-flex>
                    <v-flex xs12 v-if="!loading">
                        <v-data-table :headers="headers" :items="disagdata" :key="id"
                            :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                            <template slot="headerCell" slot-scope="props" v-if="table_buffer">
                                <v-tooltip top eager>
                                <span slot="activator" :style="$store.state.textFormatting.main">
                                    {{ props.header.text }}
                                </span>
                                <span :style="$store.state.textFormatting.main">
                                    {{ props.header.ad_text }}
                                </span>
                                </v-tooltip>
                            </template>
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.peer_asn]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.peer_asn }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.peer_asn] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.peer_asn]" :style="$store.state.textFormatting.main"> {{ props.item.peer_asn }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.prefix}}</td>
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.observation_time_date }}</td>
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.observation_time_time }}</td>
                                </tr>
                            </template>
                        </v-data-table>  
                    </v-flex>
                    <v-flex xs12 md6 v-if="ShowNoData">
                        <v-card>
                            <v-card-text>
                                <h3 :style="$store.state.textFormatting.main"> BGP Spotlight has not processed any messages for this prefix  </h3>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>

 
import ScatChart from '../../shared/operational/scatter-graph.js';
import downloadcsv from 'vue-json-csv';
import { API, graphqlOperation } from 'aws-amplify';
import info from './infopopout.vue';
import moment from 'moment-timezone';

export default {
    name: 'dissag',
    description: 'Connecting to a REST API which is being hosted to an EC2 box this page is designed to allow the user to quiry prefixs where they belive a dissagrigation has occured.',
    components: {
        ScatChart,
        info,
        downloadcsv
    },
    props: ['disag_events'],
    data () {
        return  {
            tz: 'UTC',
            rowsPerPageItems: [20, 30, 40, 50],
            pagination: {
                rowsPerPage: 10
            },
            ShowGraphAndTableInDOM: false,
            ShowNoData: false,
            loading: false,
            InputPrefix: "10.10.10.0/24",
            minTime: 999999999999,
            routePrefix: false,
            v4rules: [ v => !!v || 'A valid Ipv4 is required', v => /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([8-9]|[1-2][0-9]|3[0-2]))?$/.test(v) || 'Address must be valid' ],
            headers: [
                { text: 'Origin ASN', value:'origin_asn_new', align:'centre'},
                { text: 'Peer ASN', value:'peer_asn', align:'centre'},
                { text: 'Prefix', value:'prefix', align:'centre'},
                { text: 'Date', value:'time_exact', align:'centre'},
                { text: 'Time', value:'time_exact', align:'centre'},
                
                ],
            isThereALabel: false,
            disagdata: [],
            options: {
                tooltips: {
                    bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
                    callbacks: {
                        label: function(tooltipItem, data) {

                                var label;
                                var dataPointEpochTimeInHRFormat = new Date (data.datasets[tooltipItem.datasetIndex].data[0].x *1000)
                                label = "Time/Date: " + dataPointEpochTimeInHRFormat.toLocaleString() || 'No time Given';

                                var ListofPrefixs = ""
                                for (var i = 0; i < data.datasets[tooltipItem.datasetIndex].data.length; i=i+1) {
                                    if (data.datasets[tooltipItem.datasetIndex].data[i].x == tooltipItem.xLabel &&
                                    data.datasets[tooltipItem.datasetIndex].data[i].index.split('/')[1] == tooltipItem.yLabel) {
                                        ListofPrefixs += data.datasets[tooltipItem.datasetIndex].data[i].index +", "
                                    }
                                }
                                label += "    Prefixes: " + ListofPrefixs
                            
                            if (data.datasets[tooltipItem.datasetIndex].label != "Withdraw") {
                                label += "    Origin ASN: " + data.datasets[tooltipItem.datasetIndex].label                             
                            } else {
                                label += "    Origin ASN: No Origin ASN"         
                            }

                            return label;
                        }
                    }
                },
                title: {
                    display: true,
                    text: '',
                    fontSize: 16
                },
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                    },
                },
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Subnet',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            min: 0,
                            max: 32,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            fontSize: this.$store.state.textFormatting.chart.axis_label,
                            callback: (value, index, values) => {
                                var dataPointEpochTimeInHRFormat = new Date (value *1000);
                                let dateTime = dataPointEpochTimeInHRFormat.toLocaleString().split(", ");
                                return dateTime[0].split("/")[0] + "/" + dateTime[0].split("/")[1] + " " + dateTime[1].split(":")[0] + ":" + dateTime[1].split(":")[1];  
                            }
                        }
                    }]
                },
                pan: {
                    passive: true,
                    enabled: true,
                    mode: 'x'
                },
                zoom: {
                    passive: true,
                    enabled: true,
                    mode: 'x',
                },
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 0.1,
                passive: true
                
            },
            id: 1,
            scatdata2: {},
            sampleDataSet: {datasets: [
                {
                    label: 'Scatter Dataset 1',
                    fill: false,
                    borderColor: '#f87979',
                    backgroundColor: '#f87979',
                    data:   [
                            { x: -2, y: 4 }, 
                            { x: -1, y: 1 },
                            { x: 0, y: 0 }, 
                            { x: 1, y: 1 }, 
                            { x: 2, y: 4 }]
                    }
                ]
            },
            showAll: true,
            distinct_colors: [
                '#e6194b', 
                '#3cb44b', 
                '#ffe119', 
                '#4363d8', 
                '#f58231', 
                '#911eb4', 
                '#46f0f0', 
                '#f032e6', 
                '#bcf60c', 
                '#fabebe', 
                '#008080', 
                '#e6beff', 
                '#9a6324', 
                '#fffac8', 
                '#800000', 
                '#aaffc3', 
                '#808000', 
                '#ffd8b1', 
                '#000075', 
                '#808080', 
                //'#ffffff', remove white
                '#000000'
            ],
            asn_own_dict: {},
            asn_get_owner: [],
            table_buffer: true
        }
    },
    mounted () {
        this.apiresponsechart()
    },
    methods: {

        createTableDataForDisAgInfo: function (disagInfo) {
            var asnList = []
            for (var x = 0; x< disagInfo.length; x = x+1) {
                asnList.push(disagInfo[x].origin_asn_new)
            }

            var col_used = 0;

            var uniqueASNs = asnList.filter(this.onlyUnique)

            if (uniqueASNs.length > 14 ) {
                this.options.legend.display = false
            }

            var fullDataSet = {datasets: []};
            uniqueASNs.sort()
            for (var asnNum = 0; asnNum < uniqueASNs.length; asnNum = asnNum+1) {

                var color = this.distinct_colors[col_used]
                col_used += 1;
                var tempDatasetForGraph =  { 
                    label: uniqueASNs[asnNum],
                    fill: false,
                    borderColor: color, 
                    backgroundColor: color, 
                    pointHitRadius: '2', 
                    pointBorderWidth: '5',
                    pointHoverBorderWidth: '4',
                    data:  []
                }
            
                for (var i = 0; i< disagInfo.length; i = i+1) {
                    if (disagInfo[i].origin_asn_new == uniqueASNs[asnNum]) {
                        var prefixSubnet = null;
                        prefixSubnet = parseInt(disagInfo[i].prefix.split('/')[1])
                        if (prefixSubnet > this.options.scales.yAxes[0].ticks.max) {
                            this.options.scales.yAxes[0].ticks.max = prefixSubnet;
                        }
                        var coodernates = { x:disagInfo[i].time_exact, 
                        y: prefixSubnet, index: disagInfo[i].prefix}

                        
                        if (disagInfo[i].message_type == "A") {
                            disagInfo[i].message_type = "Announcement"
                        } else if (disagInfo[i].message_type == "W") {
                            disagInfo[i].message_type = "Withdrawal"
                        }

                        tempDatasetForGraph.data.push(coodernates)
                    
                    }
                }
            
                fullDataSet.datasets.push(tempDatasetForGraph)
            }

            

            return fullDataSet

        },
        apiresponsechart: async function () {
            this.loading = true;
            this.ShowNoData = false;
            this.ShowGraphAndTableInDOM = false


            try {
                
                var disaggHistoryDataPreCleanse = this.disag_events
               // console.log(disaggHistoryDataPreCleanse)
                var disaggHistoryData = []
                var cidr;
                for (var i = 0; i< disaggHistoryDataPreCleanse.length; i =i+1) {
                    cidr = parseInt(disaggHistoryDataPreCleanse[i].prefix.split("/")[1])
                    
                    if (cidr > 7) {
                        disaggHistoryData.push(disaggHistoryDataPreCleanse[i])
                    }
                
                }
                var tableData = this.createTableDataForDisAgInfo(disaggHistoryData)
                if (tableData.datasets.length > 10) {
                    this.options.legend.display = false // hide the legend if too many ASNs
                }

                for (var i = 0; i< disaggHistoryData.length; i =i+1) {
                    var tempDateTime = this.convertEpochtoTimeDate(disaggHistoryData[i].time_exact)
                    disaggHistoryData[i].observation_time_date =tempDateTime.date
                    disaggHistoryData[i].observation_time_time =tempDateTime.time
                    
                    if (!(this.asn_get_owner.includes(disaggHistoryData[i].peer_asn.toString()))) {
                       this.asn_get_owner.push(disaggHistoryData[i].peer_asn.toString())
                    }
                    if (!(this.asn_get_owner.includes(disaggHistoryData[i].origin_asn_new.toString()))) {
                        this.asn_get_owner.push(disaggHistoryData[i].origin_asn_new.toString())
                    }

                    disaggHistoryData[i].origin_asn_new = disaggHistoryData[i].origin_asn_new.toString()
                    disaggHistoryData[i].peer_asn = disaggHistoryData[i].peer_asn.toString()
                    
                    if (disaggHistoryData[i].message_type == "A") {
                        disaggHistoryData[i].message_type = "Announcement"
                    } else if (disaggHistoryData[i].message_type == "W") {
                        disaggHistoryData[i].message_type = "Withdrawal"
                    }

                    if ( i == disaggHistoryData.length - 1) {
                        this.getASNOwners()
                    }
                }

                this.id = this.id +1;
                this.scatdata2 = tableData
                this.disagdata = disaggHistoryData
                
                if (this.disagdata.length > 0) {
                    this.loading = false;
                    this.ShowGraphAndTableInDOM = true
                } else {
                    this.loading = false;
                    this.ShowNoData = true
                }
            } catch (err) {
                console.log(err)
                this.loading = false
                this.ShowNoData = true
            }
            
        
        },
        getAnASNOwner: async function(asn) {
            //console.log("getting asn owner: " + asn)
            if (asn == 0 || asn == 'N/A') {
                return "None";
            } else if (asn == 'Restricted Prefix') {
                return "Restricted Prefix"
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                //console.log(asn.toString() + " " + ownData[0].organisation)
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
          //  console.log("gettign asn owners")
            var nero = {}
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    this.table_buffer = false;
                    this.$nextTick(() => {
                        // Add the component back in
                        this.table_buffer = true;
                    });
                }
            }
        },
        onlyUnique: function (value, index, self) { //returns unique values in a list

            return self.indexOf(value) === index;
        },
        convertEpochtoTimeDate: function (epochTime) {
            try {
        //        var d_t = new Date(epochTime * 1000);

        //        var date = d_t.toLocaleString().substr(0, 10);
        //        var time = d_t.toLocaleString().substr(11, 9);

                var dateFormatted = moment.unix(epochTime).tz(this.tz).format('DD/MM/YYYY')
                var timeFormatted = moment.unix(epochTime).tz(this.tz).format('HH:mm:ss')
                var dateTime = { date: dateFormatted, time: timeFormatted, epoch: epochTime };

                return dateTime;                }
            catch(err) {
                console.log(this.tz)
                console.log(epochTime)
                console.log(err)
            }

        },
        disagRoute: function () {
            this.$router.push({ name: 'Disaggregation', 
                        params: {prefix: this.prefixFromAlert}})
        },

    },
    watch: {
        /*disag_events: {
            deep: true,
            handler() {
                this.apiresponsechart()
            }
        }*/
    }
}
</script>

<style scoped>

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

</style>